import React from 'react';
import classnames from 'classnames';
import OtpInput from 'react-otp-input';
import * as S from './UpdateDetailsForm.styles';
import {TEXT_INPUT, OTP_INPUT} from '../../../../../shared/CommonConfigs/FormFieldsConfig.js';

const UserInputs = ({
  type,
  inputField,
  defaultValue,
  register,
  onChange,
  value,
  classes,
  label,
  otpLength = 6,
  isEditable,
}) => {
  const renderField = type => {
    switch (type) {
      case TEXT_INPUT:
        return (
          <S.TextInputContainer>
            <p className="inputLabel">{label}</p>
            <input
              readOnly={isEditable === false ? true : false}
              className={classnames(classes)}
              defaultValue={defaultValue}
              {...register}
            />
          </S.TextInputContainer>
        );
      case OTP_INPUT:
        return (
          <S.InputCont>
            <OtpInput
              containerStyle={'otpInputBox'}
              numInputs={otpLength}
              value={value}
              onChange={onChange}
            />
          </S.InputCont>
        );
      default:
        return <></>;
    }
  };
  return <>{renderField(type)}</>;
};

export default UserInputs;
